import { Exclude } from "class-transformer";
import { s3Util } from "../util/aws/s3-util";
import { AfterLoad, Column, Entity, JoinColumn, ManyToOne } from "typeorm";
import { Brand } from "./brand.entity";
import { CommonColumns } from "./common-columns.entity";

export enum CouponUseWhen {
  NOW = 'now',  // すぐに使う（メール送信なし）
  LATER = 'later',  // あとで使う（メール送信あり）
}

export enum CouponDispType {
  DAY = 'day',  // 当日以内ならいつでも使用可能
  MIN = 'min',  // 指定分数が経過すると消える
}

@Entity()
export class Coupon extends CommonColumns {

  @ManyToOne(() => Brand, { nullable: false, })
  @JoinColumn({ name: 'brand_id', referencedColumnName: 'id', })
  brand?: Brand;

  @Column({ name: 'brand_id', })
  brandId: number;

  // いつ使うか
  // now = 即座に使う
  // later = begin_after_hour時間後から使用可能
  @Column({
    name: 'use_when',
    type: 'enum',
    enum: CouponUseWhen,
  })
  useWhen: CouponUseWhen;

  @Column()
  title: string;

  @Exclude()
  @Column()
  memo: string;

  @Column({ name: 'top_message', })
  topMessage: string;

  @Column({ name: 'image_url', })
  imageUrl: string;

  psImageUrl?: string;

  // 有効期間開始日時を「X時間後」で指定
  @Column({ name: 'begin_after_hour', })
  beginAfterHour: number;

  // 有効期間終了日を「X日後」で指定。日単位で時間を切り上げる
  @Column({ name: 'usable_days', })
  usableDays: number;

  // クーポン表示種別
  // day 当日中、ずっと表示
  // min 指定分数の間だけ表示
  @Column({
    name: 'disp_type',
    type: 'enum',
    enum: CouponDispType,
  })
  dispType: CouponDispType;

  // クーポンを何分間表示するか
  @Column({ name: 'disp_span', })
  dispSpan: number;

  @Column()
  caution: string;

  @Exclude()
  @Column('timestamp with time zone', { name: 'start_date' })
  startDate: Date;

  @Exclude()
  @Column('timestamp with time zone', { name: 'end_date' })
  endDate: Date;

  @Column()
  usage?: string;

  @AfterLoad()
  async setPsImageUrl?() {
    this.psImageUrl = await s3Util.getClientPsUrl({
      companyId: -1,  // 管理画面ができるまでは、companyIdを保持させず常に-1をセットする
      brandId: this.brandId,
      subKey: `coupon_images/${this.id}.png`,
    });
  }
}
